// 获取assets静态资源
export function getAssetsUrl(url) {
  return new URL(`../assets/${url}`, import.meta.url).href
}

/**
 * 时间格式化
 */
export function formatDate(cellValue) {
  if (cellValue == null || cellValue == '') return ''
  var date = new Date(cellValue)
  var year = date.getFullYear()
  var month =
    date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

  return year + '-' + month + '-' + day
}
